document.addEventListener('DOMContentLoaded', () => {
    const $html = document.querySelector('html.make-booking.thanks');
    if (!$html) return;

    const $bookingApp = $html.querySelector('#booking-app');
    if (!$bookingApp) return;

    // Track newsletter signup
    if ($html.classList.contains('booking-subscribed')) {
        setTimeout(() => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'newsletter_signup',
                method: 'booking_flow'
            });
        }, 1000);
    }

    // Track purchase
    if (_gaEcommerce) {
        setTimeout(() => {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'purchase',
                transaction_id: _gaEcommerce.transaction.id,
                affiliation: _gaEcommerce.transaction.affiliation,
                value: _gaEcommerce.transaction.revenue,
                currency: 'AUD',
                items: [
                    {
                        item_id: _gaEcommerce.item.sku,
                        item_name: _gaEcommerce.item.name,
                        item_category: _gaEcommerce.item.category,
                        price: _gaEcommerce.item.price,
                        quantity: _gaEcommerce.item.quantity,
                        booking_type: _gaEcommerce.item.booking_type
                    }
                ]
            });
        }, 1000);
    }
});
